import Loading from "components/Loading";
import { ProhibitionDetailPopup } from "components/pop-up/ProhibitionDetailPopup";
import { useAuth } from "context/AuthContext";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ProhibitionRequest, Referral } from "types";
import { ITEMS_PER_PAGE } from "utils/constant";
import ProsecutorDecisionPopup from "../Descision/ReferralDecision/AddProsecutorDecision";

const AssetReferralProhibition: React.FC<{
  prohibition_records: ProhibitionRequest[];
  referralId: string;
  referralData: Referral;
  handleAssetCreated: () => void;
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
  isAssetProsecutor: boolean;
  isAssetCoordinator: boolean;
  isAssetRegistrar: boolean;
  onNewDataAdded: () => void;
  setReferralData: React.Dispatch<React.SetStateAction<Referral | null>>;
  fileRowProps: any;
}> = ({
  prohibition_records = [],
  referralId,
  referralData,
  handleAssetCreated,
  setActiveTab,
  isAssetProsecutor,
  isAssetCoordinator,
  isAssetRegistrar,

  onNewDataAdded,
  setReferralData,
  fileRowProps,
}) => {
  const { loginData } = useAuth();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
  const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
  const paginatedRequests = prohibition_records.slice(
    indexOfFirstItem,
    indexOfLastItem,
  );
  const totalPages = Math.ceil(prohibition_records.length / ITEMS_PER_PAGE);

  // Helper function to format date
  const formatDate = (dateString: string | null) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString();
  };
  const [selectedProhibition, setSelectedProhibition] = useState(null);
  const [isDetailPopupOpen, setIsDetailPopupOpen] = useState(false);

  const handleViewDetails = (record: any) => {
    setSelectedProhibition(record);
    setIsDetailPopupOpen(true);
  };
  const [isAssetDecisionPopupOpen, setIsAssetDecisionPopupOpen] = useState<{
    open: boolean;
    mode: "create" | "edit";
    prohibitionId?: string | null;
    prohibitionData?: ProhibitionRequest | null;
  }>({
    open: false,
    mode: "create",
    prohibitionId: null,
    prohibitionData: null,
  });

  const handleEditProhibition = (prohibition: ProhibitionRequest) => {
    setIsAssetDecisionPopupOpen({
      open: true,
      mode: "edit",
      prohibitionId: prohibition.id,
      prohibitionData: prohibition,
    });
  };
  const handleClosePopup = () => {
    setIsAssetDecisionPopupOpen({
      open: false,
      mode: "create",
      prohibitionId: null,
      prohibitionData: null,
    });
  };
  return (
    <div className="max-w-screen-xl ml-1 mr-4 space-y-6">
      <div className="overflow-hidden bg-white shadow rounded-xl">
        {loading ? (
          <Loading label="Loading Prohibition Requests" />
        ) : (
          <table className="w-full text-sm border-collapse">
            <thead className="text-white bg-black">
              <tr>
                <th colSpan={7} className="p-4 rounded-t-lg">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2 text-lg font-semibold">
                      <span>Prohibition Requests List</span>
                    </div>
                  </div>
                </th>
              </tr>
              <tr>
                <th className="p-3 text-left">Request ID</th>
                <th className="p-3 text-left">Court Name</th>
                <th className="p-3 text-left">Status</th>
                <th className="p-3 text-left">Forward Status</th>
                <th className="p-3 text-left">Created Date</th>
                <th className="p-3 text-left">Assets Count</th>
                <th className="p-3 text-left rounded-tr-lg">Action</th>
              </tr>
            </thead>
            <tbody>
              {paginatedRequests.map((request, idx) => (
                <tr
                  key={request.id}
                  className={idx % 2 === 0 ? "bg-[#F7F4F1AB]" : "bg-white"}
                >
                  <td className="p-3 font-medium">
                    {request?.id.substring(0, 8)}...
                  </td>
                  <td className="p-3 font-[500] font-[Poppins]">
                    {request?.prohabition_court_name || "N/A"}
                  </td>
                  <td className="p-3 font-[500] font-[Poppins]">
                    <p className="bg-gray-100 rounded text-gray-800 p-2 w-fit">
                      {request?.status}
                    </p>
                  </td>
                  <td className="p-3 font-[500] font-[Poppins]">
                    {request?.forward_status || "N/A"}
                  </td>
                  <td className="p-3 font-[500] font-[Poppins]">
                    {formatDate(request?.created_at)}
                  </td>
                  <td className="p-3 font-[500] font-[Poppins]">
                    <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded">
                      {request?.count_suspect_asset?.length || 0}
                    </span>
                  </td>
                  <td className="p-3 font-[500] font-[Poppins]">
                    <div className="flex items-center gap-2">
                      <button
                        type="button"
                        onClick={() => handleViewDetails(request)}
                        className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-full transition-colors"
                        title="View"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                          />
                        </svg>
                      </button>

                      {isAssetProsecutor && (
                        <button
                          type="button"
                          onClick={() => handleEditProhibition(request)}
                          className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-full transition-colors"
                          title="Edit"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                            />
                          </svg>
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
              {prohibition_records.length === 0 && (
                <tr>
                  <td colSpan={7} className="p-4 text-center text-gray-500">
                    No prohibition requests found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex justify-center items-center gap-2 mt-4">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
          >
            Prev
          </button>
          <span className="px-2">
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
            className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
          >
            Next
          </button>
        </div>
      )}
      <ProhibitionDetailPopup
        isOpen={isDetailPopupOpen}
        onClose={() => setIsDetailPopupOpen(false)}
        prohibitionData={selectedProhibition}
        isAssetCoordinator={isAssetCoordinator}
        isAssetProsecutor={isAssetProsecutor}
        isAssetRegistrar={isAssetRegistrar}
        onNewDataAdded={onNewDataAdded}
        referral={referralData}
        referralId={referralId}
        setReferralData={setReferralData}
        fileRowProps={fileRowProps}
      />
      <ProsecutorDecisionPopup
        isOpen={isAssetDecisionPopupOpen.open}
        onClose={() =>
          setIsAssetDecisionPopupOpen({
            open: false,
            mode: "create",
            prohibitionId: null,
            prohibitionData: null,
          })
        }
        mode={isAssetDecisionPopupOpen.mode}
        prohibitionId={isAssetDecisionPopupOpen.prohibitionId} // The ID of the prohibition to edit
        editData={isAssetDecisionPopupOpen.prohibitionData} // The prohibition data object
        referralId={referralId}
        referral={referralData}
        onDecsionCreated={handleAssetCreated}
        setActiveTab={setActiveTab}
        onEditComplete={() => {
          // Optional: Do something after edit is complete
          console.log("Edit completed");
        }}
        assetsNeedingReport={referralData?.suspect_asset_counts ?? []}
      />
    </div>
  );
};

export default AssetReferralProhibition;
